export function parseEtc4(raw) {
  if (!raw) {
    return {};
  }

  if (typeof raw === "object") {
    return raw;
  }

  try {
    return JSON.parse(raw) || {};
  } catch (_e) {
    return {};
  }
}

export function getCorpUserDisplayName(user) {
  if (!user || typeof user !== "object") {
    return "";
  }

  return user.realname || user.username || "";
}

export function renderApprovalDisplay({
  approvedAt,
  corpUserId,
  displayName,
  allowAuto = true,
  formatAt,
}) {
  if (!approvedAt) {
    return "";
  }

  const at = formatAt ? formatAt(approvedAt) : String(approvedAt);

  if (!at) {
    return "";
  }

  const name = (displayName || "").trim();

  if (name) {
    return `${at}(${name})`;
  }

  if (corpUserId) {
    return at;
  }

  if (allowAuto) {
    return `${at}(자동승인)`;
  }

  return at;
}
